import { render, staticRenderFns } from "./detail-report.vue?vue&type=template&id=7ed14732&scoped=true"
import script from "./detail-report.vue?vue&type=script&lang=js"
export * from "./detail-report.vue?vue&type=script&lang=js"
import style0 from "./detail-report.vue?vue&type=style&index=0&id=7ed14732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed14732",
  null
  
)

export default component.exports